import getObjectProperty from '../../../utils/getObjectProperty';

export default (context, actions) => {
  const state = context.store.state;
  return {
    message: getObjectProperty(() => state.message, 'Unknown error'),
    subMessage: getObjectProperty(() => state.subMessage, null),
    header: getObjectProperty(() => state.header, 'Error'),
  };
};



// WEBPACK FOOTER //
// ./src/ui/views/Error/mapper.js